import React from 'react';
import { BudgetItemDto, BudgetItemSource } from '@/types';
import { Trans } from '@lingui/react/macro';

export function getDisplayText(item: BudgetItemDto) {
    if (item.source === BudgetItemSource.BuyerOptionOneTimeFee) {
        return <Trans>One-time fee for selecting options</Trans>;
    }

    return (
        <>
            {item.displayName}{' '}
            <small>
                <i>{item.customFieldData}</i>
            </small>
        </>
    );
}

export { default } from './Budget';
